import { render } from "./KycView.vue?vue&type=template&id=3c3592a0&scoped=true&ts=true"
import script from "./KycView.vue?vue&type=script&lang=ts"
export * from "./KycView.vue?vue&type=script&lang=ts"

import "./KycView.vue?vue&type=style&index=0&id=3c3592a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3592a0"],['__file',"src/views/KycView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c3592a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c3592a0', __exports__)) {
    api.reload('3c3592a0', __exports__)
  }
  
  module.hot.accept("./KycView.vue?vue&type=template&id=3c3592a0&scoped=true&ts=true", () => {
    api.rerender('3c3592a0', render)
  })

}


export default __exports__